<div class="block">

  <h1>Kontohantering</h1>
  <div>
      @if (isAdminOrExternalPlanner) {
        <button [routerLink]="['/accounts', 'new']" class="tabbable no-outline right">
          <span class="icon-plus icon__small"></span>
        </button>
      } 
    <woo-tabs [default]="'agency_customers'">
      @if (hasAccessToTab(Tab.AgencyCustomers)) {
        <woo-tab label="Byråkunder" name="agency_customers">
            <div class="tabbable__panel panel-padding clearfix shadow-z-1">
              <div class="col-sm-12">
                <h2>Byråkunder</h2>
              </div>
            </div>
            <div class="tabbable__body clearfix shadow-z-1">
              <name-list [loader]="!hasLoaded.agencyCustomers" [objects]="agencyCustomers" [inactiveObjects]="inactiveAgencyCustomers" routePath="customer"
                [showNicknames]="show.nicknames"></name-list>
            </div>
        </woo-tab>
      }
      @if (hasAccessToTab(Tab.Agencies)) {
        <woo-tab label="Byråer" name="agencies">
          <div class="tabbable__panel panel-padding clearfix shadow-z-1">
            <div class="col-sm-12">
              <h2>Byråer</h2>
            </div>
          </div>
          <div class="tabbable__body clearfix shadow-z-1">
            <name-list [loader]="!hasLoaded.agencies" [objects]="agencies" routePath="agency" [showNicknames]="show.nicknames"></name-list>
          </div>
        </woo-tab>
      }
      @if (hasAccessToTab(Tab.DirectCustomers)) {
        <woo-tab label="Direktkunder" name="customers"> 
          <div class="tabbable__panel panel-padding clearfix shadow-z-1">
            <div class="col-sm-12">
              <h2>Direktkunder</h2>
          </div>
          </div>
          <div class="tabbable__body clearfix shadow-z-1">
            <name-list [loader]="!hasLoaded.clients" [objects]="clients" routePath="customer" [showNicknames]="show.nicknames"></name-list>
          </div>
        </woo-tab>
      }
      @if (hasAccessToTab(Tab.Users)) {
        <woo-tab label="WOO-användare" name="users">
          <div class="tabbable__panel panel-padding shadow-z-1 clearfix">
            <div class="col-sm-12">
              <h2>WOO-användare</h2>
            </div>
          </div>
          <div class="tabbable__body clearfix shadow-z-1">
            <user-list [loader]="!hasLoaded.users" [activeUsers]="activeUsers" [inactiveUsers]="inactiveUsers"></user-list> 
          </div>          
        </woo-tab>
      }
    </woo-tabs>
    <div class="clearfix"></div>
  </div>
</div>
